'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;
// import convert from '../../helpers/convert'

// import ReactTooltip from 'react-tooltip'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _AutocompleteSearch = require('./AutocompleteSearch.css');

var _AutocompleteSearch2 = _interopRequireDefault(_AutocompleteSearch);

var _reactSlidedown = require('react-slidedown');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _reactFlexboxGrid = require('react-flexbox-grid');

var _reactAutosuggest = require('react-autosuggest');

var _reactAutosuggest2 = _interopRequireDefault(_reactAutosuggest);

var _reactRedux = require('react-redux');

var _search = require('redux/modules/search');

var searchActions = _interopRequireWildcard(_search);

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getSelectedSuggestion(selectedSuggestion, suggestions, method) {
  if (method !== 'up' && method !== 'down') {
    return selectedSuggestion;
  }
  var inc = null;
  if (method === 'up') {
    if (selectedSuggestion === null) return suggestions.length - 1;
    inc = -1;
  } else if (method === 'down') {
    if (selectedSuggestion === null) return 0;
    inc = 1;
  }
  selectedSuggestion = selectedSuggestion + inc;
  selectedSuggestion = selectedSuggestion < 0 || selectedSuggestion >= suggestions.length ? null : selectedSuggestion;
  return selectedSuggestion;
}

var AutocompleteSearch = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    result: state.search.result,
    searching: state.search.loading,
    searched: state.search.loaded,
    error: state.search.error
  };
}, searchActions), _dec2 = (0, _reactCssModules2.default)(_AutocompleteSearch2.default, { allowMultiple: true }), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(AutocompleteSearch, _Component);

  function AutocompleteSearch(props) {
    (0, _classCallCheck3.default)(this, AutocompleteSearch);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AutocompleteSearch.__proto__ || (0, _getPrototypeOf2.default)(AutocompleteSearch)).call(this, props));

    _this.onSuggestionsFetchRequested = function (_ref) {
      var value = _ref.value,
          reason = _ref.reason;

      if (!value || value.length < 2) {
        _this.setState({
          suggestions: [],
          notFound: false
        });
        return;
      }
      _this.setState({ selectedSuggestion: null });
      _this.handleSearch(value);
    };

    _this.onMouseEnter = function (prop) {
      return function () {
        // this.state.onHovers[prop] = true
        var onHovers = (0, _assign2.default)({}, _this.state.onHovers);
        onHovers[prop] = true;
        _this.setState({ onHovers: onHovers });
        // console.log('enter:',onHovers )
      };
    };

    _this.onMouseLeave = function (prop) {
      return function () {
        var onHovers = (0, _assign2.default)({}, _this.state.onHovers);
        delete onHovers[prop];
        _this.setState({ onHovers: onHovers });
        // console.log('leave:',onHovers )
        // console.log('leave:',this.state.onHovers )
      };
    };

    _this.onChange = function (event, _ref2) {
      var newValue = _ref2.newValue,
          method = _ref2.method;

      var selectedSuggestion = getSelectedSuggestion(_this.state.selectedSuggestion, _this.state.suggestions, method);
      _this.setState({
        value: newValue,
        selectedSuggestion: selectedSuggestion
      });
    };

    _this.onKeyUp = function (event, data) {
      if (event.key === 'Enter' && _this.suggestionSelected === false) {
        _this.onSubmit();
      }
    };

    _this.onSubmit = function () {
      _this.context.router.push({
        pathname: '/funds',
        query: { q: _this.state.value }
      });
    };

    _this.onSuggestionSelected = function (event, _ref3) {
      var suggestion = _ref3.suggestion,
          suggestionValue = _ref3.suggestionValue,
          sectionIndex = _ref3.sectionIndex,
          method = _ref3.method;

      // need a way to suppress the keyup enter event, dont want to push twice to the router
      _this.suggestionSelected = true;
      var name = _format2.default.sanitize(suggestion.fund_legal_name);
      var ticker = suggestion.ticker ? suggestion.ticker : 'N';
      var fund_id = suggestion.fund_id,
          investment_vehicle_id = suggestion.investment_vehicle_id;

      var pathSegment = null;
      switch (_config2.default.app.title) {
        case 'Fossil Free Funds':
          pathSegment = 'fossil-fuel-investments';
          break;
        case 'Deforestation Free Funds':
          pathSegment = 'profile';
          break;
        case 'Tobacco Free Funds':
          pathSegment = 'tobacco-profile';
          break;
        case 'Weapon Free Funds':
          pathSegment = 'weapon-investments';
          break;
        case 'Gender Equality Funds':
          pathSegment = 'gender-lens-score';
          break;
        case 'Gun Free Funds':
          pathSegment = 'gun-investments';
          break;
        case 'Prison Free Funds':
          pathSegment = 'prison-industrial-complex-investments';
          break;
        default:
          pathSegment = 'profile';
          break;
      }

      var path = '/fund/' + name + '/' + ticker + '/' + pathSegment + '/' + fund_id + '/' + investment_vehicle_id;
      _this.context.router.push({ pathname: path });
    };

    _this.onSuggestionsClearRequested = function () {
      _this.setState({
        suggestions: [],
        notFound: false
      });
    };

    _this.getSuggestionValue = function (suggestion) {
      // when suggestion selected, this function tells
      // what should be the value of the input
      return suggestion.name ? suggestion.name : suggestion.fund_legal_name ? suggestion.fund_legal_name : _this.state.value;
    };

    _this.suggestionSelected = false;
    _this.lastHandleSearch = null;

    _this.handleSearch = function (name) {
      // add a delay
      var time = new Date().getTime();
      _this.lastHandleSearch = time;
      setTimeout(function () {
        // if time hasnt been update then hit search
        if (time === _this.lastHandleSearch) {
          _this.setState({ searchReq: name });
          _this.props.searchFunds(name);
        }
      }, 100);
    };

    _this.renderSuggestion = function (suggestion, _ref4) {
      var value = _ref4.value,
          valueBeforeUpDown = _ref4.valueBeforeUpDown;

      // console.log('render:',suggestion )
      return _react2.default.createElement(
        _reactFlexboxGrid.Row,
        { styleName: 'suggestion-row' },
        _react2.default.createElement(
          _reactFlexboxGrid.Col,
          { xs: 6, styleName: 'suggestion-name' },
          suggestion.name
        ),
        _react2.default.createElement(
          _reactFlexboxGrid.Col,
          { xs: 3, styleName: 'suggestion-ticker' },
          suggestion.ticker
        ),
        _react2.default.createElement(
          _reactFlexboxGrid.Col,
          { xs: 3, styleName: 'suggestion-family' },
          suggestion.fund_family_name
        )
      );
    };

    _this.state = {
      value: '',
      selectedSuggestion: null,
      suggestions: [],
      onHovers: {},
      notFound: false,
      searchReq: null
    };
    return _this;
  }

  (0, _createClass3.default)(AutocompleteSearch, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.result && nextProps.result.results && this.state.searchReq === nextProps.result.req) {
        var state = {
          suggestions: nextProps.result.results || []
        };
        if (nextProps.result && nextProps.result.results.length === 0) {
          state = (0, _assign2.default)({}, state, {
            notFound: true
          });
        }
        this.setState(state);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          value = _state.value,
          suggestions = _state.suggestions;

      var inputProps = {
        id: 'search',
        name: 'search',
        title: 'search',
        placeholder: 'Search funds by name, ticker, or manager',
        value: value,
        onChange: this.onChange,
        onKeyUp: this.onKeyUp
      };

      return _react2.default.createElement(
        'div',
        { styleName: 'autocomplete-submit' },
        _react2.default.createElement(
          'label',
          { htmlFor: 'search' },
          _react2.default.createElement(
            _components.SrOnly,
            null,
            'Search'
          )
        ),
        _react2.default.createElement(_reactAutosuggest2.default, {
          theme: _AutocompleteSearch2.default,
          suggestions: suggestions,
          onSuggestionsFetchRequested: this.onSuggestionsFetchRequested,
          getSuggestionValue: this.getSuggestionValue,
          renderSuggestion: (0, _reactCssModules2.default)(this.renderSuggestion, _AutocompleteSearch2.default),
          onSuggestionSelected: this.onSuggestionSelected,
          onSuggestionsClearRequested: this.onSuggestionsClearRequested,
          inputProps: inputProps
        }),
        this.props.searching ? _react2.default.createElement(
          'div',
          { styleName: 'submit' },
          _react2.default.createElement(_reactLoader2.default, { options: { scale: 0.50, top: '50%' } })
        ) : _react2.default.createElement('div', {
          styleName: 'submit',
          onClick: this.onSubmit,
          className: 'fa fa-search',
          title: 'Submit search'
        }),
        this.state.notFound ? _react2.default.createElement(
          'div',
          { styleName: 'autocomplete-notfound-wrap' },
          _react2.default.createElement(
            'div',
            { styleName: 'autocomplete-notfound' },
            'Sorry, no results found'
          )
        ) : null
      );
    }
  }]);
  return AutocompleteSearch;
}(_react.Component), _class2.propTypes = {
  searching: _react.PropTypes.bool,
  searched: _react.PropTypes.bool,
  error: _react.PropTypes.object,
  result: _react.PropTypes.object,
  search: _react.PropTypes.func
}, _class2.contextTypes = {
  router: _react.PropTypes.object.isRequired
}, _temp)) || _class) || _class);
exports.default = AutocompleteSearch;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/core/AutocompleteSearch/AutocompleteSearch.js
// module id = 1335
// module chunks = 0